<template>
  <div @dragover="onDragOver" @drop="onDrop" class="mt-2 flex justify-center rounded-lg border-2 border-dashed border-gray-900/25 px-6 py-4">
    <div class="text-center">

      <PhotoIcon class="mx-auto size-12 text-gray-300"/>

      <div class="mt-2 flex text-sm/6 text-gray-600">
        <label for="file-upload" class="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 focus-within:outline-hidden hover:text-indigo-500">
          <span v-if="selectedFile">{{ selectedFile.name }}</span>
          <span v-else>Upload een bestand</span>
          <input id="file-upload" type="file" class="hidden" @change="onChange" accept=".pdf">
        </label>

        <p v-if="!selectedFile" class="pl-1">of sleep en zet het hier neer</p>
      </div>

      <p v-if="!selectedFile" class="text-xs/5 text-gray-600">Alleen PDF bestanden, maximaal {{maxSize}}MB</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { watch } from 'vue'
import { PhotoIcon } from '@heroicons/vue/24/solid'

const selectedFile = defineModel<File|null>({
  default: null
});

const { maxSize } = defineProps<{
  readonly maxSize: number;
}>();

function onChange(event: any): void {
  if (event.target.files == null) return;

  if (event.target.files.length >= 2) {
    alert("Cannot upload more then 1 file");

    return;
  }

  updateFile(event.target.files[0]);
}

function onDragOver(event: DragEvent): void {
  event.preventDefault();
}

function onDrop(event: DragEvent): void {
  event.preventDefault();

  if (event.dataTransfer == null) return;

  if (event.dataTransfer.files.length >= 2) {
    alert("Cannot upload more then 1 file");

    return;
  }

  updateFile(event.dataTransfer.files[0]);
}

function updateFile(file: File): void {
  const allowedSize = maxSize * 1024 * 1024;

  if (file.size >= allowedSize) {
    alert(`File size has to be below ${allowedSize}mb!`);

    return;
  }

  if (file.type !== "application/pdf") {
    alert("Only .PDF files are allowed!");

    return;
  }

  selectedFile.value = file;
}

watch(selectedFile, (newVal, _) => selectedFile.value = newVal);
</script>